import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';
import { ToastService } from 'src/app/service/toast.service';
import { DatePipe } from '@angular/common';
import { Constants } from 'src/app/constants/constants';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'saved-payment-instruments',
  templateUrl: './saved-payment-instruments.component.html',
  styleUrls: ['./saved-payment-instruments.component.scss']
})
export class SavedPaymentInstrumentsComponent implements OnInit {

  @Input() accountPaymentSetting: any;
  @Input() invoice: any;
  @Output() paymentStatusEmitter: EventEmitter<any> = new EventEmitter<any>();

  paymentTypes: Array<string> = ["ACH", "CARD"];
  selectedPaymentInstrument: any;
  selectedPaymentInstrumentIndex: number;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private route: ActivatedRoute, private utilService: UtilService, private toast: ToastService, private datePipe: DatePipe) { }

  ngOnInit() {
  }

  confirmPayment() {
    document.getElementById('closeConfirmationModal').click();
    // document.getElementById("openSavedAccountModal").click();
    this.payUsingSavedInstrument(this.selectedPaymentInstrument);
  }

  cancelPayment() {
    document.getElementById('closeConfirmationModal').click();
    document.getElementById("openSavedAccountModal").click();
  }

  makePayment(instrument: any) {
    var payload = {
      "amount": this.invoice.invoiceSummary.total,
      "instrumentId": instrument.instrumentId,
      "invoiceId": this.invoice.invoiceId,
      "paymentOrigin": "ECOMMERCE"
    }
    console.log("saved instrument payment payload::", payload);
    this.selectedPaymentInstrument = payload;
    document.getElementById('closeSavedAccountModal').click();
    document.getElementById('openConfirmationModal').click();
    // this.payUsingSavedInstrument(payload);
  }

  goToPaymentScreen() {
    document.getElementById("closeSavedAccountModal").click();
    document.getElementById("openPaymentOptionsModal").click();
  }

  payUsingSavedInstrument(payload) {
    // this.accountPaymentSetting = null;
    this.utilService.showSpinner();
    this.apiService.payUsingSavedInstrument(payload).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data.status);
      document.getElementById("closeSavedAccountModal").click();
      var emittingData = {
        "savedInstrument": true,
        "instrument" : data.instrument,
        "autoPay": this.accountPaymentSetting.paymentSetting
      }
      this.paymentStatusEmitter.emit(emittingData);
      console.log("account payment setting data::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.payUsingSavedInstrument(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });

  }

  getLastFourDigit(account: string) {
    if(isNullOrUndefined(account))
      return account;
    return account.substr(account.length - 4);
  }

  getPaymentIcon(cardType: string) {
    if(Constants.PAYMENT_CARDS_LOGO.has(cardType)) {
      return Constants.PAYMENT_CARDS_LOGO.get(cardType);
    }
    return null;
  }

  getPaymentIcon1(cardType: string) {
    if(Constants.PAYMENT_CARDS.has(cardType.toLowerCase())) {
      return Constants.PAYMENT_CARDS.get(cardType.toLowerCase());
    } else {
      return Constants.PAYMENT_CARDS.get('credit-card');
    }
  }

}
